import createActionTypes from './createActionTypes'

export const namespace = 'FEED'

export const types = createActionTypes(namespace, [
  'SET_FEED_MODE',
  'SET_FEED_LOADING',
  'SET_FEED_QUERY',
  'SET_FEED_PAGE',
])

export const setFeedMode = isFeedMode => ({
  type: types.SET_FEED_MODE,
  payload: { isFeedMode },
})

export const setFeedLoading = isLoading => ({
  type: types.SET_FEED_LOADING,
  payload: { isLoading },
})

export const setFeedQuery = query => ({
  type: types.SET_FEED_QUERY,
  payload: { query },
})

export const setFeedPage = ({ items, page, totalCount }) => ({
  type: types.SET_FEED_PAGE,
  payload: { items, page, totalCount },
})
